import React from 'react';
import { MembershipAccordionVariant, MembershipBoxAccordionProps } from '../Types';
import * as S from './MembershipBoxAccordion.styles';
import BlockContent from '../../block-content/BlockContent';

export const MembershipBoxAccordion = ({
  title,
  content,
  showIcon = true,
  variant = MembershipAccordionVariant.Available,
  noBackground = false,
  onExpand,
}: MembershipBoxAccordionProps) => (
  <S.StyledAccordion
    headingLevel={3}
    title={title ?? ''}
    size="small"
    hideDivider
    onChange={({ value }) => value && onExpand?.()}
    $variant={variant}
    $showIcon={showIcon}
    $noBackground={noBackground}
  >
    <BlockContent value={content} />
  </S.StyledAccordion>
);
